<template>

    <div class=" w-full text-blue-800 bg-white h-auto py-20">



        <div class=" text-center  ">

            <h1 class=" md:text-4xl sm:text-2xl text-xl mb-4"> Nos qualités </h1>

            <hr class="W-1/4 mx-auto mb-10 shadow-4xl">
        </div>

        <div class="sm:flex content-center justify-center">


            <div class=" sm:w-2/4 w-3/4 mx-auto h-auto my-6 lg:mx-8 md:mx-4">
                <h3 class="text-center text-xl my-2">                 <font-awesome-icon
                                                                                         class="text-4xl"
                                                                                         :icon="['fas', 'clock']"
                /> </h3>
                <p class=" text-sm text-justify mx-4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime
                    vitae,
                    nesciunt
                    ipsa
                    deleniti asperiores
                    provident velit similique officiis ab reiciendis cupiditate illo incidunt aspernatur magnam dolorem
                    quae. Facere, ex voluptatum.</p>
            </div>


            <div class=" sm:w-2/4 w-3/4 mx-auto h-auto my-6 lg:mx-8 md:mx-4">
                <h3 class="text-center text-xl my-2"> <font-awesome-icon
                        class="text-4xl"
                        :icon="['fas', 'check']"
                /> </h3>
                <p class=" text-sm text-justify mx-4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime
                    vitae,
                    nesciunt
                    ipsa
                    deleniti asperiores
                    provident velit similique officiis ab reiciendis cupiditate illo incidunt aspernatur magnam dolorem
                    quae. Facere, ex voluptatum.</p>
            </div>

            <div class=" sm:w-2/4 w-3/4 mx-auto h-auto my-6 lg:mx-8 md:mx-4">
                <h3 class="text-center text-xl my-2"><font-awesome-icon
                        class="text-4xl"
                        :icon="['fas', 'file-export']"
                /><br> </h3>
                <p class=" text-sm text-justify mx-4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime
                    vitae,
                    nesciunt
                    ipsa
                    deleniti asperiores
                    provident velit similique officiis ab reiciendis cupiditate illo incidunt aspernatur magnam dolorem
                    quae. Facere, ex voluptatum.</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "skills"
    }
</script>

<style scoped>

</style>
